module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "text-info",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99/99/9999'),
      expression: "'99/99/9999'"
    }],
    staticClass: "form-control",
    class: _vm.additionalClass,
    attrs: {
      "type": "text",
      "autocomplete": "false",
      "name": _vm.name,
      "required": _vm.required,
      "placeholder": _vm.placeholder,
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value || false
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28926076!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputDate.vue
// module id = 286
// module chunks = 18